import { render, staticRenderFns } from "./ListePaiementTreated.vue?vue&type=template&id=4a27b688&scoped=true&"
import script from "./ListePaiementTreated.vue?vue&type=script&lang=js&"
export * from "./ListePaiementTreated.vue?vue&type=script&lang=js&"
import style0 from "./ListePaiementTreated.vue?vue&type=style&index=0&id=4a27b688&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a27b688",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCard,VCardTitle,VDivider,VSheet,VSkeletonLoader})
